import { render, staticRenderFns } from "./LField.vue?vue&type=template&id=28bd10b0"
import script from "./LField.vue?vue&type=script&lang=js"
export * from "./LField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports